import React from 'react';
import { useMenu, useMenuHeader } from './hooks';
import { LoadingWrapper } from '../util/ui/Loading';
import { MenuHeaderView } from './MenuHeaderView';
import { MenuHeader } from './model/MenuHeader';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { MenuView } from './MenuView';
import Menu from './model/Menu';
import ColumnLayout from '../util/ui/ColumnLayout';

export function MenuViewerPage() {
    return (<MenuViewerPageBase />);
}

function MenuViewerPageBase() {
    const menu = useMenu();
    const menuHeader = useMenuHeader();
    const classes = useStyles();

    return (
        <ColumnLayout>
            <div className={classes.root}>
                <LoadingWrapper content={
                    (menu.obj !== undefined && menuHeader.obj !== undefined) && (
                        <React.Fragment>
                            <div className={classes.content}>
                                <MenuHeaderView menuHeader={new MenuHeader(menuHeader.obj)} />
                            </div>
                            <div className={classes.content}>
                                <MenuView menu={new Menu(menu.obj)} />
                            </div>
                        </React.Fragment>
                    )} />
            </div>
        </ColumnLayout>
    )
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            padding: '10px 10px 0px 10px',
        },
        content: {
            maxWidth: '1024px',
            width: '100%',
            marginBottom: '16px',
        },
    }));
